// css =>
import "../../BaseStructure.css";
import Styled from "./portfolio-services-box.module.css";

// context =>
import { useTheme } from '../../context/theme-context';

// language =>
import { useLanguage } from '../../context/language-context';

const PortfolioServiceBox = (props) => {
    const { theme } = useTheme();
    const { language } = useLanguage();

    return (
        <div 
            className={`col-2 ${ Styled.portfolio_service_box } `}
            onClick={props.onClick}
            role='button'
            tabIndex={ 0 }
            onKeyDown={(e) => e.key === 'Enter' && props.onClick()}
            style={{
                float: language === "fa" ? "left" : ""
            }}>
            <div className="col-12">
                <img src={ props.servicePicture } alt={ props.serviceName } />
            </div>

            <p
                style={{
                    color: theme === "day" ? "#000000" : ""
                }}>{ props.serviceName }</p>
        </div>
    );
}

export default PortfolioServiceBox;
